import React, { Fragment, useEffect, useState } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import PageTitle from "../../Layout/AppMain/PageTitle";
import AppContent from "../AppContent";
import { DataGrid } from "@mui/x-data-grid";
import {
  Card,
  CardBody,
  InputGroup,
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Row,
  Col,
  Input,
  InputGroupText,
} from "reactstrap";
import {
  getPublicVendors,
  DeletePublicVendors,
} from "../../services/PublicvendorService";
import { debounce, hasValue } from "../../utils/commonFns";
import { faRotate, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AddPublicVendors from "./AddUpdatePublicVendors";
import ConfirmationModal from "../Common/ConfirmationModal";

export default function PublicVendors() {
  const [isNewPublicVendorsModalOpen, setPublicVendorsModalOpen] =
    useState(false);
  const [selectedPublicVendorsId, SetPublicVendorsId] = useState(null);

  const [isNewConfirmationModalOpen, setisNewConfirmationModalOpen] =
    useState(false);
  const [deleteText, SetDeleteText] = useState(null);

  const colDefs = [
    {
      field: "name",
      headerName: "Name",
      width: 250,
      renderCell: (params) => {
        return (
          <a
            style={{
              textDecoration: "underline !important",
              color: "#545cd8",
              cursor: "pointer",
            }}
            onClick={() => {
              SetPublicVendorsId(params.row.id);
              setPublicVendorsModalOpen(true);
            }}
          >
            {params.value}
          </a>
        );
      },
    },
    {
      field: "universalName",
      headerName: "Universal Name",
      width: 200,
    },
    {
      field: "website",
      headerName: "Website",
      width: 200,
    },
    {
      field: "linkedinUrl",
      headerName: "Linked-In Url",
      width: 200,
    },
    {
      field: "id",
      headerName: "Delete",
      width: 200,
      renderCell: (params) => {
        return (
          <FontAwesomeIcon
            title="Delete"
            icon={faTrash}
            onClick={() => {
              SetDeleteText(`Do you want to delete "${params.row.name}"?`);
              setisNewConfirmationModalOpen(true);
              SetPublicVendorsId(params.value);
            }}
            style={{ paddingLeft: "15px" }}
          />
        );
      },
    },
  ];

  const [vendorData, setVendorData] = useState([]);
  const [nameFilter, setNameFilter] = useState("");

  const setIsNewPublicVendorsModalOpen = (show, success) => {
    setPublicVendorsModalOpen(show);
    if (success) fetchData();
  };

  const setConfirmationModalOpen = (show, success) => {
    setisNewConfirmationModalOpen(show);
    if (success) {
      deleteData(selectedPublicVendorsId);
    }
  };

  const deleteData = async (id) => {
    const data = await DeletePublicVendors(id);
    if (hasValue(data)) {
      fetchData();
    }
  };

  const fetchData = async () => {
    const data = await getPublicVendors(nameFilter);
    if (hasValue(data)) {
      setVendorData(data);
    } else {
      setVendorData([]);
    }
  };

  useEffect(() => {
    processDebounce();
  }, [nameFilter]);

  const processDebounce = debounce(() => fetchData(), 1000);

  return (
    <AppContent>
      <Fragment>
        <TransitionGroup>
          <CSSTransition
            component="div"
            className="TabsAnimation"
            appear={true}
            timeout={0}
            enter={false}
            exit={false}
          >
            <div>
              <PageTitle
                heading="Public Vendors"
                BreadcrumbComp={
                  <Breadcrumb>
                    <BreadcrumbItem>
                      <a href="#">Home</a>
                    </BreadcrumbItem>
                    <BreadcrumbItem active>Public Vendors</BreadcrumbItem>
                  </Breadcrumb>
                }
                PageTitleActions={
                  <>
                    <Button
                      color="primary"
                      onClick={() => {
                        SetPublicVendorsId(null);
                        setPublicVendorsModalOpen(true);
                      }}
                    >
                      + New Vendor
                    </Button>
                  </>
                }
              />
              <Card className="main-card mb-3">
                <CardBody>
                  <Row style={{ marginTop: 8, marginBottom: 16 }}>
                    <Col sm={2}>
                      <InputGroup>
                        <Input
                          type="text"
                          name="name"
                          autocomplete="off"
                          value={nameFilter}
                          onChange={(e) => {
                            setNameFilter(e.target.value);
                          }}
                          id="name"
                          placeholder="Search with Name"
                        />

                        <InputGroupText>
                          <FontAwesomeIcon
                            title="Refresh"
                            icon={faRotate}
                            onClick={() => {
                              fetchData();
                            }}
                          />
                        </InputGroupText>
                      </InputGroup>
                    </Col>
                    <Col></Col>
                  </Row>
                  <div className="public-vendor-grid-container">
                    <DataGrid
                      rows={vendorData}
                      columns={colDefs}
                      pageSize={20}
                      disableSelectionOnClick
                      disableRowSelectionOnClick
                      density="compact"
                    />
                  </div>
                </CardBody>
              </Card>
              {isNewPublicVendorsModalOpen && (
                <AddPublicVendors
                  isNewPublicVendorsModalOpen={isNewPublicVendorsModalOpen}
                  setIsNewPublicVendorsModalOpen={
                    setIsNewPublicVendorsModalOpen
                  }
                  PublicVendorsId={selectedPublicVendorsId}
                />
              )}
              {isNewConfirmationModalOpen && (
                <ConfirmationModal
                  isNewConfirmationModalOpen={isNewConfirmationModalOpen}
                  setConfirmationModalOpen={setConfirmationModalOpen}
                  bodyText={deleteText}
                />
              )}
            </div>
          </CSSTransition>
        </TransitionGroup>
      </Fragment>
    </AppContent>
  );
}
